/**
 * Mobile Menu
 */

export default (() => {
  const toggler = document.querySelector('.menu-toggler')
  const menu = document.querySelector('.menu-list')

  if (!toggler || !menu) return

  toggler.addEventListener('click', () => {
    toggler.classList.toggle('active')
    menu.classList.toggle('expanded')
  })
})()
